import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2a9ac6",
      light: "#5bc4f0",
      dark: "#1d7396",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#2c3e50",
      light: "#4a6785",
      dark: "#1a252f",
    },
    success: {
      main: "#27ae60",
      light: "#58d68d",
    },
    warning: {
      main: "#f39c12",
      light: "#f7c948",
    },
    error: {
      main: "#e74c3c",
      light: "#f1948a",
    },
    background: {
      default: "#f5f6fa",
      paper: "#ffffff",
    },
    text: {
      primary: "#2c3e50",
      secondary: "#7f8c8d",
    },
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h4: {
      fontWeight: 700,
      fontSize: "1.75rem",
    },
    h5: {
      fontWeight: 600,
      fontSize: "1.5rem",
    },
    h6: {
      fontWeight: 600,
      fontSize: "1.125rem",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          borderRadius: 12,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 8,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-head": {
            fontWeight: 700,
            backgroundColor: "#f8f9fa",
            color: "#2c3e50",
          },
        },
      },
    },
  },
});

export default theme;
